export enum DefaultProfileType {
  EFI = 'efi',
  EGI = 'egi',
  FEED_STRATEGY = 'feedstrategy',
  HARVEST_TARGET = 'harvesttarget',
  MORTALITY = 'mortality',
}
